<template>
    <div>
        <AppBreadCrumb :paths="[{ title: 'Fatura Yönetimi', path: '/billing' }, { title: 'Planlar' }]" :select="true" />
        <CreditCardNeeded v-if="creditCardRequired" @close="creditCardRequired = null" />
        <CancelPlanModal
            v-if="cancelPlanModal"
            @confirm="unsubscribe(cancelPlanModal)"
            @reject="cancelPlanModal = false"
        />
        <CreatePlanModal
            v-if="subscribePlanModal"
            @confirm="subscribe(subscribePlanModal)"
            @reject="subscribePlanModal = false"
            :planPeriod="period"
            :plan="subscribePlanModal"
        />
        <DowngradeWarn v-if="showWarn" @close="showWarn = null" @forward="forwardPage">
            <template v-if="showWarn == 'supsis'">
                Paketiniz düşürülemiyor. Paketinizi düşürmek için lütfen Temsilcilerinizden bir kaçını siliniz veya
                devredışı bırakınız.
            </template>
            <template v-else-if="showWarn == 'whatsapp'">
                Paketiniz düşürülemiyor. Paketinizi düşürmek için lütfen Whatsapp Kanalarınızdan bir kaçını siliniz.
            </template>
            <template v-else-if="showWarn == 'whatsapp-business'">
                Paketiniz düşürülemiyor. Paketinizi düşürmek için lütfen Whatsapp Business Kanalarınızdan bir kaçını
                siliniz.
            </template>
        </DowngradeWarn>
        <div class="billing-plans">
            <div class="title">
                <div>
                    <div>
                        {{
                            type
                                ? type
                                      .split("-")
                                      .map((c) => c[0].toUpperCase() + c.slice(1).toLowerCase())
                                      .join(" ")
                                : ""
                        }}
                        Planınızı Seçiniz
                    </div>
                    <div class="plan-select-options">
                        <div style="width: max-content">
                            <div class="option-title">Şunun için hesapla:</div>
                            <div class="option-description">Yıllık paketlerde %30 indirimi yakala!</div>
                            <ChangePlan v-model="period" />
                        </div>
                        <div
                            style="width: max-content"
                            v-if="['supsis', 'whatsapp-business', 'whatsapp'].includes(type)"
                        >
                            <div class="option-title">
                                {{
                                    type == "supsis"
                                        ? "Temsilci Sayınız"
                                        : ["whatsapp-business", "whatsapp"].includes(type)
                                        ? "Kanal Sayısı"
                                        : ""
                                }}
                            </div>
                            <div class="option-description">
                                {{
                                    type == "supsis"
                                        ? "Maximun konuşacak temsilci sayısı"
                                        : ["whatsapp-business", "whatsapp"].includes(type)
                                        ? "Whatsapp kanal sayısı"
                                        : ""
                                }}
                            </div>
                            <div class="classic-counter-group" v-if="['supsis'].includes(type)">
                                <div
                                    @click="details.agentCount > 1 && details.agentCount--"
                                    class="classic-counter-button"
                                >
                                    -
                                </div>
                                <div>
                                    <a-input-number v-model="details.agentCount" :min="1" class="counter" />
                                </div>
                                <div @click="details.agentCount++" class="classic-counter-button">+</div>
                            </div>
                            <div class="classic-counter-group" v-if="['whatsapp-business', 'whatsapp'].includes(type)">
                                <div
                                    @click="details.whatsappChannel > 1 && details.whatsappChannel--"
                                    class="classic-counter-button"
                                >
                                    -
                                </div>
                                <div>
                                    <a-input-number v-model="details.whatsappChannel" :min="1" class="counter" />
                                </div>
                                <div @click="details.whatsappChannel++" class="classic-counter-button">+</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="lightbulb"
                    v-tippy="{ followCursor: true, placement: 'bottom-end', maxWidth: 500, arrow:true, offset: '0, 15' }"
                    :content="$t('chatbotv2.plansVTippyContent')"

                >
                    <div class="material-icons">lightbulb</div>
                </div>
            </div>
            <div class="content">
                <div class="supsis-plans">
                    <Card
                        v-for="(plan, index) of allPlans[type]"
                        :key="index"
                        :plan="plan"
                        :period="period"
                        :details="details"
                        @subscribe="onSubscribe"
                        @unsubscribe="(payload) => (cancelPlanModal = payload)"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import _ from "lodash";
import Card from "../../../components/billing/Card.vue";
import AppBreadCrumb from "../../../components/common/AppBreadCrumb";
import ChangePlan from "../../../components/billing/new/ChangePlan.vue";
import CancelPlanModal from "../../../components/billing/CancelPlanModal.vue";
import CreatePlanModal from "../../../components/billing/CreatePlanModal.vue";
import CreditCardNeeded from "../../../components/billing/CreditCardNeeded.vue";
import DowngradeWarn from "../../../components/DowngradeWarn.vue";
import moment from "moment";

export default {
    name: "BillingPlans",
    components: {
        Card,
        AppBreadCrumb,
        CancelPlanModal,
        CreatePlanModal,
        ChangePlan,
        DowngradeWarn,
        CreditCardNeeded,
    },
    data: () => {
        return {
            period: "monthly",
            type: null,
            cancelPlanModal: false,
            subscribePlanModal: false,
            details: {
                agentCount: 1,
                whatsappChannel: 1,
            },
            showWarn: null,
            creditCardRequired: false,
        };
    },
    mounted() {
        this.type = this.$route.params.type;
        const currentPlan = this.currentPlans[this.$route.params.type];
        if (currentPlan) this.period = currentPlan.plan.period;
        if (["supsis", "whatsapp", "whatsapp-business"].includes(this.type) && currentPlan) {
            this.details = this.$_.cloneDeep(currentPlan.plan.details);
        }
    },
    methods: {
        ...mapActions({
            subscribePlan: "site/subscribePlan",
            unsubscribePlan: "site/unsubscribePlan",
        }),
        onSubscribe(payload) {
            this.subscribePlanModal = payload;
        },
        subscribe(payload) {
            if (this.type == "supsis" && payload.details.agentCount < this.users.length) {
                this.showWarn = "supsis";
                return;
            }
            if (this.type === "whatsapp-bussines" && payload.details.whatsappChannel < this.businessChannels.length) {
                this.showWarn = "whatsapp-bussines";
                return;
            }
            if (this.type === "whatsapp" && payload.details.whatsappChannel < this.channels.length) {
                this.showWarn = "whatsapp";
                return;
            }
            if (
                this.sitePaymentMethod === "credit-card" &&
                (!this.billingDetail || !this.billingDetail.binNumber) &&
                this.trialInfo.remainingDays <= 0
            ) {
                this.creditCardRequired = true;
                return;
            }
            this.subscribePlanModal = null;

            this.subscribePlan(payload).then((action) => {
                if (!action || !action.planType) {
                    this.$toasted.error(
                        !this.billingDetail || !this.billingDetail.binNumber
                            ? "Lütfen Kredi Kartınızı Giriniz."
                            : "Geçersiz kredi kartı, Ödeme Alınamadı.",
                        {
                            duration: 3000,
                            position: "top-center",
                        }
                    );

                    return;
                }
                this.goBack();
            });
        },
        forwardPage() {
            if (this.showWarn == "supsis") this.$router.push("/users");
            if (this.showWarn == "whatsapp") this.$router.push("/integrations/whatsapp-v1");
            if (this.showWarn == "whatsapp-business") this.$router.push("/integrations/whatsapp-business-api");
        },
        unsubscribe(payload) {
            this.unsubscribePlan(payload);
            this.cancelPlanModal = false;
            this.goBack();
        },
        goBack() {
            this.$router.push({
                path: `/billing`,
            });
        },
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            siteId: (state) => state.site.site._id,
            currentPlans: (state) => state.site.currentPlans,
            allPlans: (state) =>
                _.groupBy(
                    state.site.plans.filter((p) => !p.isDeleted),
                    (plan) => plan.dynamicType || plan.type
                ),
            channels: (state) =>
                state.channel.channels.filter(
                    (x) => x.type === "whatsapp-v1" || x.type === "whatsapp-qr" || x.type === "whatsapp-v2"
                ),
            businessChannels: (state) => state.channel.channels.filter((x) => x.type === "whatsapp-business-api"),
            users: (state) => state.user.users.data.filter((user) => user.enable),
            billingDetail: (state) => state.site.billingDetail,
            sitePaymentMethod: (state) => state.site.site?.paymentMethod || "credit-card",
            trialInfo: (state) => {
                const site = state.site.site;
                if (site) {
                    const { createdAt } = site;
                    const tookDays = Math.max(moment().diff(moment(createdAt, "YYYY-MM-DD"), "day"), 0);
                    const isTrial = tookDays < _.get(state.setting.settings, "plan.trialDays");
                    return {
                        trial: isTrial,
                        remainingDays: isTrial ? _.get(state.setting.settings, "plan.trialDays") - tookDays : 0,
                    };
                } else {
                    return { trial: false, remainingDays: 0 };
                }
            },
        }),
    },
    watch: {
        currentPlans: {
            handler(newVal) {
                const currentPlan = newVal[this.$route.params.type];
                if (currentPlan) this.period = currentPlan.plan.period;
                if (["supsis", "whatsapp", "whatsapp-business"].includes(this.type) && currentPlan) {
                    this.details = this.$_.cloneDeep(currentPlan.plan.details);
                }
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss">
.billing-plans {
    padding: 30px 30px;

    .title {
        font-size: 24px;
        font-weight: bold;
        color: black;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .lightbulb {
            white-space: pre-wrap;
            background: #ec4b1d;
            border-radius: 50px;
            padding: 10px;
            color: white;
            cursor: pointer;
        }
    }
    .plan-select-options {
        margin-top: 10px;
        display: flex;
        align-items: center;
        gap: 30px;
        .option-title {
            font-size: 16px;
            color: #da5731;
        }
        .option-description {
            font-size: 14px;
            margin-bottom: 5px;
            font-weight: normal;
        }
    }

    .classic-counter-group {
        display: flex;
        align-items: center;
        gap: 10px;
        .classic-counter-button {
            background-color: rgb(236, 75, 29);
            width: 35px;
            height: 35px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 30px;
            color: white;
            cursor: pointer;
            font-size: 18px;
            font-weight: normal;
            user-select: none;
        }
    }

    .supsis-slider {
        .ant-slider-track,
        .ant-slider-rail {
            height: 8px !important;
        }

        .ant-slider-handle {
            width: 17px !important;
            height: 17px !important;
            margin-top: -4px !important;
        }
    }

    .content {
        margin-top: 20px;

        .ant-slider-handle {
            background: rgb(236, 75, 29);
            border-color: rgb(236, 75, 29);

            :focus {
                box-shadow: none;
                -webkit-box-shadow: none;
            }
        }

        .ant-slider-track {
            background: rgb(236, 75, 29);
        }

        .supsis-plans {
            display: flex;
        }
    }
}
</style>
